//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OperatorCommand: any = {
    PutOperatorUpdate: Backofficebff + '/v1/operator/update',
    PostAddOperatorToRole: Backofficebff + '/v1/operator/addoperatorrole',
    PostOperatorCreate: Backofficebff + '/v1/operator/create',
    DeleteOperatorFromRole: Backofficebff + '/v1/operator/removefromrole',
    PostCreateRole: Backofficebff + '/v1/operator/role/create',
    PutUpdateRole: Backofficebff + '/v1/operator/role/update',
    DeleteRole: Backofficebff + '/v1/operator/role',
    DeleteRoleAuthorization: Backofficebff + '/v1/operator/role/authorization',
    PostRoleAuthorizationAdd: Backofficebff + '/v1/operator/role/authorization/add',
    PostRoleAuthorizationBulkAdd: Backofficebff + '/v1/operator/role/authorization/bulk-add',
    UpdateApplicationUser: Backofficebff + '/v1/operator/update-application-user',
    UpdateHarmonyData: Backofficebff + '/v1/operator/update-harmony-data',
    GetOperatorsByOperatorId: Backofficebff + '/v1/operator/get-operators-by-operatorid',
    UpdateOperatorIdData: Backofficebff + '/v1/operator/update-operator-id-from-old-backoffice',
    TransferRole: Backofficebff + '/v1/operator/transfer-role',
};
